module.exports = __webpack_public_path__ + "static/5_736_1128-f50767d148e8f87fc0ceac265cf39f74.jpg";